import {ActionTree} from "vuex";
import {RootState} from "../types/RootState";
import {MiniPlayerState, MiniPlayerParams} from "../types/MiniPlayerState";

export const actions: ActionTree<MiniPlayerState, RootState> = {
    setMiniPlayerParams({ commit }, params: MiniPlayerParams) {
        commit("setObject", params.object);
        commit("setVideoController", params.videoController);
        commit("setReturnRouteName", params.returnRouteName)
    },
    setShowPlayer({ commit }, isVisible: boolean) {
        commit("setShowPlayer", isVisible)
    },
    clearParams({ commit }) {
        commit("setObject", null);
        commit("setVideoController", null)
    },
    pauseVideo({ state, dispatch }) {
        const pause = state.videoController?.pause;
        if (typeof pause === "function") {
            pause();
        }

        dispatch("setPaused", true);
    },
    setPaused({ commit }, paused) {
        commit("setPaused", paused)
    }
};